import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { GameData } from "../Channels/Common/Datas/GameData";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator, WinAnimatorAttributes } from "../GameComponents/WinAnimator";
import { Tweens } from "../Components/Effects/Tweens";
import { PlayList } from "../Components/Sounds/PlayList";
import { SoundManager } from "../Components/Managers/SoundManager";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { Payline } from "../GameComponents/Payline";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { AnimationElement } from "../Components/Elements/Graphics/AnimationElement";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    private singleLine: boolean = false;

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.singleLine = false;

        super.onReelStopped(reelsData, reelIndex);

        this.impactSpecialSymbols(reelsData, reelIndex);

        if (reelIndex == 5 && this.countScatters(reelIndex) < 4) {
            for (let i: number = 0; i <= reelIndex; i++) {
                for (let j: number = 0; j < reelsData[i].symbols.length; j++) {
                    if (reelsData[i].symbols[j] === 12 && this.currentSymbols[i][j] != null) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    }
                }
            }
        }
    }

    private impactSpecialSymbols(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.tease(reelIndex);
        this.impactWilds(reelsData, reelIndex);
    }

    protected tease(reelIndex: number): void {
        const count = this.countScatters(reelIndex);

        if (count >= this.getMinTeasingSymbolCount()) {
            this.tease3(reelIndex, count);
        } else if (count === this.getMinTeasingSymbolCount() - 1) {
            this.tease2(reelIndex, count);
        } else {
            this.tease1(reelIndex, count);
        }
    }

    protected countScatters(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            if (this.currentReels[i].symbols.indexOf(this.getTeasingSymbol()) !== -1) {
                count++;
            }
        }

        return count;
    }

    protected tease1(reelIndex: number, count: number): void {
        if (this.reelCount - reelIndex - 1 < this.getMinTeasingSymbolCount() - count) {
            return;
        }

        const symbolIndex = this.currentReels[reelIndex].symbols.indexOf(this.getTeasingSymbol());

        if (symbolIndex !== -1) {
            if (this.allowSymbolGoToCase(reelIndex, symbolIndex, Symbol.CaseImpact)) {
                this.currentSymbols[reelIndex][symbolIndex].goToCase(Symbol.CaseImpact);
                PlayList.play("SND_BaseScatter");
            }
        }
    }

    protected tease2(reelIndex: number, count: number): void {
        if (this.reelCount - reelIndex - 1 < this.getMinTeasingSymbolCount() - count) {
            for (let i = 0; i < reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    }
                }
            }

            return;
        }

        for (let i = 0; i < reelIndex; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseTease)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                    }
                } else {
                    // if (this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                    //     this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                    // }
                }
            }
        }

        this.tease3(reelIndex, count);
    }

    protected tease3(reelIndex: number, count: number): void {
        for (let i = 0; i < this.currentSymbols[reelIndex].length; i++) {
            if (this.currentSymbols[reelIndex][i].id === this.getTeasingSymbol() - 1) {
                if (this.allowSymbolGoToCase(reelIndex, i, Symbol.CaseTease)) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseTease);
                }
            } else {
                // if (this.allowSymbolGoToCase(reelIndex, i, Symbol.CaseNowin)) {
                //     this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseNowin);
                // }
            }
        }
    }

    protected getTeasingSymbol(): number {
        return 12;
    }

    protected getMinTeasingSymbolCount(): number {
        return 3;
    }

    private impactWilds(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        if (reelsData[reelIndex] != null && reelsData[reelIndex].symbols != null) {
            for (let i: number = 0; i < reelsData[reelIndex].symbols.length; i++) {
                if (reelsData[reelIndex].symbols[i] === 11 && this.currentSymbols[reelIndex][i] != null) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
                    PlayList.play("SND_BaseWild");
                }
            }
        }
    }

    private calculatePreviousStars(
        reelsData: Array<Communication.Game.IReel>,
        reelIndex: number,
        symbolId: number,
    ): number {
        let count: number = 0;
        for (let j: number = 0; j < reelIndex; j++) {
            if (reelsData[j] != null && reelsData[j].symbols != null) {
                for (let i: number = 0; i < reelsData[j].symbols.length; i++) {
                    if (reelsData[j].symbols[i] === symbolId) {
                        count++;
                    }
                }
            }
        }

        return count;
    }

    protected cycleWins(): void {
        if (this.currentWins == null) {
            return;
        }
        if (this.singleLine) {
            return;
        }

        this.dynamicTint();
        super.cycleWins();
        if (this.currentWins.length === 1) {
            this.singleLine = true;
        }
    }

    private dynamicTint(): void {
        if (
            this.currentWins != null &&
            this.currentWins[this.currentCycle] &&
            this.currentWins[this.currentCycle].paylineId != null
        ) {
            switch (this.currentWins[this.currentCycle].paylineId) {
                case 1:
                    AnimationElement.DynamicTint = "2D9900";
                    ImageElement.DynamicTint = "2D9900";
                    break;
                case 2:
                    AnimationElement.DynamicTint = "1A35CF";
                    ImageElement.DynamicTint = "1A35CF";
                    break;
                case 3:
                    AnimationElement.DynamicTint = "ff5400";
                    ImageElement.DynamicTint = "ff5400";
                    break;
                case 4:
                    AnimationElement.DynamicTint = "d000db";
                    ImageElement.DynamicTint = "d000db";
                    break;
                case 5:
                    AnimationElement.DynamicTint = "9DCC1E";
                    ImageElement.DynamicTint = "9DCC1E";
                    break;
                case 6:
                    AnimationElement.DynamicTint = "0b00d7";
                    ImageElement.DynamicTint = "0b00d7";
                    break;
                case 7:
                    AnimationElement.DynamicTint = "ffcc00";
                    ImageElement.DynamicTint = "ffcc00";
                    break;
                case 8:
                    AnimationElement.DynamicTint = "ff0072";
                    ImageElement.DynamicTint = "ff0072";
                    break;
                case 9:
                    AnimationElement.DynamicTint = "1B6600";
                    ImageElement.DynamicTint = "1B6600";
                    break;
                case 10:
                    AnimationElement.DynamicTint = "2A68FF";
                    ImageElement.DynamicTint = "2A68FF";
                    break;
                case 11:
                    AnimationElement.DynamicTint = "F66463";
                    ImageElement.DynamicTint = "F66463";
                    break;
                case 12:
                    AnimationElement.DynamicTint = "9333ff";
                    ImageElement.DynamicTint = "9333ff";
                    break;
                case 13:
                    AnimationElement.DynamicTint = "42CC98";
                    ImageElement.DynamicTint = "42CC98";
                    break;
                case 14:
                    AnimationElement.DynamicTint = "47CDFF";
                    ImageElement.DynamicTint = "47CDFF";
                    break;
                case 15:
                    AnimationElement.DynamicTint = "F42F00";
                    ImageElement.DynamicTint = "F42F00";
                    break;
                case 16:
                    AnimationElement.DynamicTint = "C535FF";
                    ImageElement.DynamicTint = "C535FF";
                    break;
                case 17:
                    AnimationElement.DynamicTint = "FACB14";
                    ImageElement.DynamicTint = "FACB14";
                    break;
                case 18:
                    AnimationElement.DynamicTint = "0600c7";
                    ImageElement.DynamicTint = "0600c7";
                    break;
                case 19:
                    AnimationElement.DynamicTint = "007388";
                    ImageElement.DynamicTint = "007388";
                    break;
                case 20:
                    AnimationElement.DynamicTint = "b425bb";
                    ImageElement.DynamicTint = "b425bb";
                    break;
                case 21:
                    AnimationElement.DynamicTint = "2D9900";
                    ImageElement.DynamicTint = "2D9900";
                    break;
                case 22:
                    AnimationElement.DynamicTint = "1A35CF";
                    ImageElement.DynamicTint = "1A35CF";
                    break;
                case 23:
                    AnimationElement.DynamicTint = "ff5400";
                    ImageElement.DynamicTint = "ff5400";
                    break;
                case 24:
                    AnimationElement.DynamicTint = "d000db";
                    ImageElement.DynamicTint = "d000db";
                    break;
                case 25:
                    AnimationElement.DynamicTint = "9DCC1E";
                    ImageElement.DynamicTint = "9DCC1E";
                    break;
                case 26:
                    AnimationElement.DynamicTint = "0b00d7";
                    ImageElement.DynamicTint = "0b00d7";
                    break;
                case 27:
                    AnimationElement.DynamicTint = "ffcc00";
                    ImageElement.DynamicTint = "ffcc00";
                    break;
                case 28:
                    AnimationElement.DynamicTint = "ff0072";
                    ImageElement.DynamicTint = "ff0072";
                    break;
                case 29:
                    AnimationElement.DynamicTint = "1B6600";
                    ImageElement.DynamicTint = "1B6600";
                    break;
                case 30:
                    AnimationElement.DynamicTint = "2A68FF";
                    ImageElement.DynamicTint = "2A68FF";
                    break;
                case 31:
                    AnimationElement.DynamicTint = "F66463";
                    ImageElement.DynamicTint = "F66463";
                    break;
                case 32:
                    AnimationElement.DynamicTint = "9333ff";
                    ImageElement.DynamicTint = "9333ff";
                    break;
                case 33:
                    AnimationElement.DynamicTint = "42CC98";
                    ImageElement.DynamicTint = "42CC98";
                    break;
                case 34:
                    AnimationElement.DynamicTint = "47CDFF";
                    ImageElement.DynamicTint = "47CDFF";
                    break;
                case 35:
                    AnimationElement.DynamicTint = "F42F00";
                    ImageElement.DynamicTint = "F42F00";
                    break;
                case 36:
                    AnimationElement.DynamicTint = "C535FF";
                    ImageElement.DynamicTint = "C535FF";
                    break;
                case 37:
                    AnimationElement.DynamicTint = "FACB14";
                    ImageElement.DynamicTint = "FACB14";
                    break;
                case 38:
                    AnimationElement.DynamicTint = "0600c7";
                    ImageElement.DynamicTint = "0600c7";
                    break;
                case 39:
                    AnimationElement.DynamicTint = "007388";
                    ImageElement.DynamicTint = "007388";
                    break;
                case 40:
                    AnimationElement.DynamicTint = "b425bb";
                    ImageElement.DynamicTint = "b425bb";
                    break;
                case 41:
                    AnimationElement.DynamicTint = "2D9900";
                    ImageElement.DynamicTint = "2D9900";
                    break;
                case 42:
                    AnimationElement.DynamicTint = "1A35CF";
                    ImageElement.DynamicTint = "1A35CF";
                    break;
                case 43:
                    AnimationElement.DynamicTint = "ff5400";
                    ImageElement.DynamicTint = "ff5400";
                    break;
                case 44:
                    AnimationElement.DynamicTint = "d000db";
                    ImageElement.DynamicTint = "d000db";
                    break;
                case 45:
                    AnimationElement.DynamicTint = "9DCC1E";
                    ImageElement.DynamicTint = "9DCC1E";
                    break;
                case 46:
                    AnimationElement.DynamicTint = "0b00d7";
                    ImageElement.DynamicTint = "0b00d7";
                    break;
                case 47:
                    AnimationElement.DynamicTint = "ffcc00";
                    ImageElement.DynamicTint = "ffcc00";
                    break;
                case 48:
                    AnimationElement.DynamicTint = "ff0072";
                    ImageElement.DynamicTint = "ff0072";
                    break;
                case 49:
                    AnimationElement.DynamicTint = "1B6600";
                    ImageElement.DynamicTint = "1B6600";
                    break;
                case 50:
                    AnimationElement.DynamicTint = "2A68FF";
                    ImageElement.DynamicTint = "2A68FF";
                    break;
            }
        }
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];
                    if (caseType === Symbol.CaseCycle) {
                        if (this.currentWins.length > 1) {
                            symbol.goToCase(Symbol.CaseCycle + "_" + i);
                        } else {
                            symbol.goToCase("SINGLE_WIN");
                        }
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                } else {
                    const symbol = this.currentSymbols[i][definition[i]];
                    if (caseType === Symbol.CaseCycle) {
                        if (symbol.getCurrentCase() !== Symbol.CaseNowin) {
                            if (this.currentWins.length > 1) {
                                symbol.goToCase("CYCLE_NOWIN_NORMAL");
                            } else {
                                symbol.goToCase("SINGLE_NOWIN_NORMAL");
                            }
                        } else {
                            if (this.currentWins.length > 1) {
                                symbol.goToCase("CYCLE_NOWIN");
                            } else {
                                symbol.goToCase("SINGLE_NOWIN");
                            }
                        }
                    }
                }
            }
        }

        return symbols;
    }

    protected winSymbolsGoToCaseAsScatter(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if ((win.mask[i] & (1 << j)) !== 0 && this.allowSymbolGoToCase(i, j, caseType)) {
                    const symbol = this.currentSymbols[i][j];
                    if (caseType === Symbol.CaseCycle) {
                        if (this.currentWins.length > 1) {
                            symbol.goToCase(Symbol.CaseCycle + "_" + i);
                        } else {
                            symbol.goToCase("SINGLE_WIN");
                        }
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    protected getAnimationIndex(): number {
        if (this.currentWins.length === 1 && this.currentWins[0].type === Communication.Game.WinType.freeSpins) {
            return 6;
        } else {
            return super.getAnimationIndex();
        }
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        if (
            (this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_2" ||
                this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle + "_3") &&
            caseType === Symbol.CaseNormal
        ) {
            return false;
        }

        return true;
    }

    protected getIdleDelay(): number {
        return 30;
    }

    protected getInitialIdleDelay(): number {
        return 30;
    }

    protected getIdleActiveElementsCount(): number {
        return 2;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/